import gql from 'graphql-tag';

export const GET_VENDOR_OPPORTUNITIES_LIST_PARTNER = gql`
  query GetVendorOpportunitiesListPartner($input: VendorOpportunitiesListInput!) {
    vendorOpportunitiesListPartner(input: $input) {
      error
      success
      total
      data {
        vendorOpportunityId
        dynamicsVendorOpportunityId
        createdOn
        salesRepresentativeId
        salesManagerId
        financeManagerId
        creditManagerId
        applicationStage
        transactionStage
        invoiceTotal
        equipmentDescription
        invoiceStatus
        statusDetail
        displayStatus
        vendorProfileId
        sourceVendorProfileId
        dealerName
        partnerRepName

        # Entities
        potentialCustomer {
          name
        }
        salesRepresentative {
          fullName
        }
        salesManager {
          fullName
        }
        financeManager {
          fullName
        }
        creditManager {
          fullName
        }
        partnerProfile {
          partnerLogo
        }
        creditApplication {
          creditApplicationId
          firstName
          lastName
          applicationType
          entityType
          applyingFor
        }
        lead {
          inboundDealType
        }
        businessProcessFlowsView {
          flowId
          department
          departmentName
          currentStageId
          currentStageName
        }
      }
    }
  }
`;
